import { createContext } from 'react';
import { EntityFieldPath } from '../Path/@Model/EntityFieldPath';
import { Entity } from '../../../../@Api/Model/Implementation/Entity';

export type InputOverrideRenderFunction = (entity: Entity, fieldPath: EntityFieldPath) => React.ReactNode | undefined;

export default createContext<InputOverrideRenderFunction>(undefined);
